import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { MDBRow, MDBCol } from "mdbreact";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import dayjs from "dayjs";

import "./VoyageForm.scss";

import { AbsCheckBox, AbsDropDown, Label, TextArea } from "abs-ui-components";
import { Input } from "abs-ui-components";

import { EVENT_OPTIONS } from "../VoyageConstants";
import Loader from "../../../../../common/Loader/Loader";
import PortCodeAutocomplete from "../PortCodeAutoComplete";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import axiosHttp from "../../../../../services/interceptor";
import * as _ from "lodash";
import { accessAPIForResponse } from "../../../../../services/api-services/api-implementations";
import { roundOff } from "../../../../../services/utilities";
import MainSectionForm from "./SubForms/MainForm";

import JourneyForm from "./SubForms/JourneyForm";
import CargoForm from "./SubForms/CargoForm";
import ROBForm from "./SubForms/ROBForm";
import ConsForm from "./SubForms/CONSForm";
import MNCForm from "./SubForms/MNCForm";
import CslipForm from "./SubForms/CslipForm";
import OtherForm from "./SubForms/OtherForms";
import OtherFuels from "./SubForms/OtherFuels";
const VoyageForm = ({
	onClose,
	editVoyage,
	type,
	voyage_sections_data,
	onRefetchVoyageAndMisStateMentErrs,
	disableBtn,
	setDisableBtn,
	isViewing,
	viewVoyage,
}) => {

	let AfTankerFields = voyage_sections_data?.sections?.find(
		(item) => item.sectionName === "AfTanker"
	);

	let refereKWHFields = voyage_sections_data?.sections?.find(
		(item) => item.sectionName === "Refer Kwh"
	);


	if (AfTankerFields) {

		// Check if AfTankerFields exist and process the sections
		voyage_sections_data?.sections?.map(
			(item) => {
				// Normalize the sectionName comparison to lower case without spaces
				if (
					(item.sectionName.replaceAll(/\s+/g, "").toLowerCase() === "tfj" || item.sectionName.replaceAll(/\s+/g, "").toLowerCase() === "fctfj")
				) {
					// Check if AfTankerFields.fields is not already appended
					// Only add AfTankerFields.fields if it is not already in item.fields
					if (!item.fields.includes(AfTankerFields.fields[0])) {
						item.fields = [
							...item.fields,
							...AfTankerFields.fields,

						];
					}
					return item;
				} else {
					return item;
				}
			}
		);
	}

	if (refereKWHFields) {

		voyage_sections_data?.sections?.map(
			(item) => {
				// Normalize the sectionName comparison to lower case without spaces
				if (
					item.sectionName.replaceAll(/\s+/g, "").toLowerCase() ===
					"fcelectrical"
				) {
					// Check if AfTankerFields.fields is not already appended
					// Only add AfTankerFields.fields if it is not already in item.fields
					if (!item.fields.includes(refereKWHFields.fields[0])) {
						item.fields = [
							...item.fields,
							...refereKWHFields.fields,

						];
					}
					return item;
				} else {
					return item;
				}
			}
		);
	}



	const reportDetails = useSelector(
		(state) => state.reports.selectedReportDetails
	);

	let dateOfVoyage = editVoyage?.TIME_STAMP
		? dayjs(`${editVoyage?.TIME_STAMP} GMT`)
		: null;
	let methods = useForm();
	const {
		watch,
		formState: { isDirty, error },
		setValue,
		reset,
	} = methods;

	const formValues = watch();
	// const isFormModified =
	// 	!isDirty ||
	// 	Object.values(formValues).some(
	// 		(value, index) =>
	// 			value !== methods.getValues(Object.keys(formValues)[index])
	// 	);
	const [loading, setLoading] = useState(false);
	const [disableAdd, setDisableAdd] = useState(true);
	const [checkSailingInIce, setCheckSailingInIce] = useState(false);
	const [isValidation, setIsValidation] = useState(false);
	const [isEdited, setEdited] = useState(false);
	const [allowedConsumers, setAllowedConsumers] = useState("");
	const [fuelsTotalSum, setFuelsTotalSum] = useState({});

	const reportFlags = useSelector((state) => state.reports.reportFlagDetails);

	// const handleBlur = async (field, value) => {
	// 	// setValue(field, roundOff(value));
	// 	if (allowedConsumers === "Template1:New") {
	// 		await trigger(field);

	// 		const mainEngineValues = getValues("FUELCONS");

	// 		// Initialize an object to hold the sums for each fuel type
	// 		const fuelSums = {
	// 			HFO: 0,
	// 			LFO: 0,
	// 			MDO: 0,
	// 			MGO: 0,
	// 			LPGP: 0,
	// 			LPGB: 0,
	// 			LNG: 0,
	// 			METHANOL: 0,
	// 			ETHANOL: 0,
	// 			OF1: 0,
	// 			OF2: 0,
	// 			OF3: 0,
	// 		};
	// 		Object?.values(mainEngineValues)
	// 			.slice(1)
	// 			.forEach((entry) => {
	// 				for (const fuelType in fuelSums) {
	// 					const fuelValue = parseFloat(entry[fuelType]);

	// 					if (!isNaN(fuelValue)) {
	// 						fuelSums[fuelType] += fuelValue;
	// 						// fuelSums[fuelType] =
	// 						// 	(fuelSums[fuelType] || 0) + fuelValue;
	// 					}
	// 				}
	// 			});

	// 		setFuelsTotalSum(fuelSums);
	// 	}
	// };

	// const getReportFlags = async () => {
	// 	await accessAPIForResponse("GetReportFlags", null, [
	// 		reportDetails.ReportMstId,
	// 	])
	// 		.then((response) => {
	// 			if (response) {
	// 				setAllowedConsumers(response.templateType);
	// 			}
	// 		})
	// 		.catch((error) => {
	// 			console.error(error);
	// 		});
	// };

	// useEffect(() => {
	// 	getReportFlags();
	// }, []);

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	const initialFormValues = useMemo(() => {
		return editVoyage || {}; // If `editBDN` data exists, use it; otherwise, use an empty object
	}, [editVoyage]);

	useEffect(() => {
		const hasChanged = Object.keys(formValues).some((key) => {
			return formValues[key] !== initialFormValues[key];
		});

		setDisableAdd(!hasChanged); // Enables button if form has changed, disables if unchanged
	}, [formValues, initialFormValues]);
	// useEffect(() => {
	// 	if (allowedConsumers === "Template1:New") {
	// 		if (fuelsTotalSum) {
	// 			Object.keys(fuelsTotalSum).forEach((fuelType) => {
	// 				// const totalsum = fuelsTotalSum !== 0 ? roundOff(fuelsTotalSum) : "";
	// 				setValue(`FUELCONS.0.${fuelType}`, fuelsTotalSum[fuelType]);
	// 			});
	// 		}
	// 	}
	// }, [fuelsTotalSum, setValue]);

	// useEffect(() => {
	// 	if (editVoyage) {
	// 		const resetValues = {};

	// 		const allowedPrefixes = ["FUELCONS"];

	// 		Object.keys(editVoyage).forEach((key) => {
	// 			if (allowedPrefixes.some((prefix) => key.startsWith(prefix))) {
	// 				resetValues[key] = editVoyage[key];
	// 			}
	// 		});

	// 		reset(resetValues);
	// 	}
	// }, [editVoyage, reset]);

	useEffect(() => {
		if (reportFlags?.templateType === "Template1:New") {
			if (editVoyage) {
				const resetValues = {};
				const allowedPrefixes = ["FUELCONS"];

				Object.keys(editVoyage).forEach((key) => {
					if (
						allowedPrefixes.some((prefix) => key.startsWith(prefix))
					) {
						resetValues[key] = editVoyage[key];
					}
				});

				reset(resetValues);
			}
		}
	}, [reportFlags, editVoyage, reset]);

	// useEffect(() => {
	// 	if (allowedConsumers === "Template1:New") {
	// 		const handleClickOutside = () => {
	// 			handleBlur();
	// 		};

	// 		document.addEventListener("click", handleClickOutside);
	// 		return () =>
	// 			document.removeEventListener("click", handleClickOutside);
	// 	}
	// }, []);

	// useEffect(() => {
	// 	// if (!editVoyage) {
	// 	const shouldEnableButton = Object.values(formValues).some(
	// 		(value) => value
	// 	);

	// 	if (
	// 		type == "Edit" &&
	// 		formValues?.EVENTTYPE &&
	// 		(formValues?.portCodeMstId !== formValues?.portCodeMstId ||
	// 			checkSailingInIce !== formValues?.SAILING_IN_ICE)
	// 	)
	// 		setEdited(true);
	// 	if (
	// 		formValues.EVENTTYPE?.value !== "NOON" &&
	// 		formValues.EVENTTYPE?.value !== "STS-OPL" &&
	// 		!formValues.portCodeMstId
	// 	) {
	// 		setIsValidation(true);
	// 		setDisableAdd(!shouldEnableButton);
	// 	} else {
	// 		setIsValidation(false);
	// 		setDisableAdd(false);
	// 	}

	// 	// }
	// }, [formValues, type == "Edit"]);

	const handleCancel = () => {
		onClose();
	};

	// Define the handler for port code change
	const portCodeChange = (obj) => {
		if (obj?.portCodeMstId === undefined) {
			setValue("portCodeMstId", null);
		} else {
			setValue("portCodeMstId", obj.portCodeMstId);
		}
	};

	const handleCheckSailingInIce = (value) => {
		// Do something with the value in the parent component
		setCheckSailingInIce(value);
	};
	const convertNestedDataToFlat = (nestedData) => {
		const fuelCategory = [
			"FUELCONS",
			"FUELROB",
			"ROB",
			"JOURNEY",
			"CARGO",
			"FCVOYAGE",
			"FCELECTRICAL",
			"FCTFJ",
			"FCOTHER",
			"MNC",
			"FCBOILER",
			"OF1",
			"OF2",
			"OF3",
			"ME",
			"AE",
			"BOILER",
			"CONSUMER1",
			"CONSUMER2",
			"CONSUMER3",
			"HFO",
			"LFO",
			"MGO",
			"MDO",
			"LPGB",
			"LPGP",
			"ETHANOL",
			"METHANOL",
			"LNG",
			"AMOUNTOFCARBONSTORAGE",
		];

		const result = [];

		// Helper function to traverse the nested object
		const traverse = (obj, path = "") => {
			if (typeof obj === "object" && obj !== null) {
				Object.keys(obj).forEach((key) => {
					const value = obj[key];
					const newPath = path ? `${path}|${key}` : key;

					if (typeof value === "object" && value !== null) {
						traverse(value, newPath);
					} else {
						if (
							fuelCategory.some((category) =>
								newPath.startsWith(category)
							)
						) {
							result.push({
								[newPath]: isNaN(parseFloat(value))
									? null
									: parseFloat(value),
							});
						}
					}
				});
			}
		};

		traverse(nestedData);

		return result;
	};
	const transformFormData = (formData, backendStructure) => {
		const transformedData = {};

		// Define fields to exclude
		const excludeFields = [
			"TIMESTAMP",
			"PORT",
			"EVENTTYPE",
			"SAILING_IN_ICE",
			"REMARKS",
			"AFTANKER",
		];

		backendStructure.sections.forEach((section) => {
			section.fields.forEach((field) => {
				const key = field.key; // Backend key like "JOURNEY|DUR_SEA"
				const cleanKey = sanitizeKey(key); // Remove '|' for formData matching

				// Check if the field is not in excludeFields and has a corresponding value in formData
				if (
					!excludeFields.includes(field.key) &&
					formData[cleanKey] !== undefined
				) {
					let value = formData[cleanKey];
					if (field.dataType === "boolean") {
						value = value === "True";
					}
					// // Process options field if it's an object
					// if (field.dataType === "options") {
					// 	if (
					// 		typeof value === "object" &&
					// 		value !== null &&
					// 		"value" in value
					// 	) {
					// 		value = String(value.value); // Extract inner value
					// 	} else {
					// 		value = String(value); // Ensure it is stringified if it's a primitive
					// 	}
					// }

					// Convert decimal fields to numeric values
					if (field.dataType === "decimal") {
						value = value ? String(parseFloat(value)) : null;

					}

					// Refined check for null assignment
					const isInvalid =
						value === "" ||
						value === undefined ||
						value === null ||
						(field.dataType === "decimal" && isNaN(value));

					// Assign value only if it's valid
					if (!isInvalid) {
						transformedData[key] = value;

					} else {
						transformedData[key] = null; // Explicitly set null for invalid entries

					}
				}
			});
		});


		return transformedData;
	};

	const handleVoyageFormSubmit = async (formData) => {
		const transformedData = transformFormData(
			formData,
			voyage_sections_data
		);
		// Convert the data
		// const flatData = convertNestedDataToFlat(formData);
		// setDisableBtn(true);

		const payload = {
			//future scope
			// isValid: true,
			// errorMessage: "",
			// isSysGenerated: false,
			// isSampleVoyage: false,
			// reportingYear: +reportDetails.ReportYear,
			reportMstId: +reportDetails?.ReportMstId,
			voyageDtlId: voyage_sections_data?.voyageDtlId,
			voyageIndex: 0,
			eventType: formData?.EVENTTYPE?.value,
			portCodeMstId: +formData?.PORT?.value || formData?.portCodeMstId,

			timeStamp: formData?.TIMESTAMP
				? dayjs(formData.TIMESTAMP)
					.utc()
					.format("YYYY-MM-DDTHH:mm:ss[Z]")
				: null,
			sailingInIce: formData.SAILING_IN_ICE || false,
			afTanker: formData.AFTANKER?.value,
			remarks: formData?.REMARKS || "",
			metadata: transformedData,
			// metadata: _.merge({}, ...flatData),
		};


		setLoading(true);

		if (type === "Add") {
			axiosHttp
				.post(`api/Voyages/AddMepcVoyage`, payload)
				.then((res) => {
					if (res && res?.data.isSuccess) {
						setLoading(false);
						onClose();
						emitToasterMsg(
							"success",
							"Voyage",
							"Added Successfully"
						);
						setDisableBtn(false);
						onRefetchVoyageAndMisStateMentErrs();
					} else {
						setLoading(false);
						setDisableBtn(false);
						emitToasterMsg(
							"error",
							"Voyage",
							res.data.errorMessage
						);
					}
				})
				.catch((error) => {
					setLoading(false);
					setDisableBtn(false);

					console.error(error);
				});
		} else {
			await axiosHttp({
				url: `api/Voyages/EditMepcVoyage?voyageDtlId=${voyage_sections_data?.voyageDtlId}`,
				method: "POST",
				data: payload,
			})
				.then((res) => {
					if (res && res?.data?.isSuccess) {
						setLoading(false);
						setDisableBtn(false);
						emitToasterMsg(
							"success",
							"Voyage",
							"Updated Successfully"
						);
						onRefetchVoyageAndMisStateMentErrs();
						onClose();
					} else {
						setLoading(false);
						setDisableBtn(false);
					}
				})
				.catch((error) => {
					setLoading(false);
					setDisableBtn(false);
					console.error(error);
				});
		}
	};

	const [expandedAccordion, setExpandedAccordion] = useState(null);

	return (
		<>
			{loading && <Loader />}
			<FormProvider {...methods}>
				{" "}
				{/* This provides the form context */}
				<form
					onSubmit={methods.handleSubmit(handleVoyageFormSubmit)}
					className="voyage-form-container"
				>
					{voyage_sections_data && (
						<>
							{voyage_sections_data?.sections?.map(
								(section, sectionIndex) => (
									<>
										<MainSectionForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
											formValues={formValues}
											isValidation={isValidation}
										/>

										<JourneyForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
										/>

										<CargoForm
											key={sectionIndex}
											section={section}
											type={type}
											onSailingInIceChange={
												handleCheckSailingInIce
											}
										/>

										<ROBForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
											expandedId={expandedAccordion}
  											setExpandedId={setExpandedAccordion}
										/>
										<ConsForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
											expandedId={expandedAccordion}
  											setExpandedId={setExpandedAccordion}
										/>
										<OtherForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
											expandedId={expandedAccordion}
  											setExpandedId={setExpandedAccordion}
										/>
										<CslipForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
										/>
										<OtherFuels
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
											expandedId={expandedAccordion}
  											setExpandedId={setExpandedAccordion}
										/>
										<MNCForm
											key={sectionIndex}
											section={section}
											sectionIndex={sectionIndex}
											type={type}
										/>
									</>
								)
							)}
							<div className="d-flex justify-content-end mr-3 center-buttons">
								<button
									type="submit"
									className={`save-button mr-3 ${disableAdd ? "dimmed" : ""
										}`}
									disabled={disableAdd}
								>
									{type === "Add" ? "Add" : "Update"}
								</button>

								<button
									className="clear-button  "
									onClick={handleCancel}
									autoFocus={false}
								>
									Cancel
								</button>
							</div>
						</>
					)}
				</form>
			</FormProvider>
		</>
	);
};

export default VoyageForm;
